const CommissionPayment = { data: [], loading: true };
export const GetComPaymentSoldReportRed = (state = CommissionPayment, action) => {
    switch (action.type) {

        case "get_allcompaymentsoldreport":
            return {
                data: action.payload,
                loading: action.loading
            }
        default:
            return state;
    }


}